import React, { useRef, useState, useEffect } from "react";

import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import styles from "./../tooltip.module.css";
import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";

import * as api from "helper/helper";
import SearchBar from "../SearchBar";
import toast from "react-hot-toast";
import ProductosTable2 from "./ProductosTable2";
import TableOptionCheck, { FilterType } from "./TableOptionCheck";
import CreateCatalogoItem from "./CreateCatalogoItem";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import ExportCSV from "../ExportCSV";
import { handleStatus } from "../../helperFunctions/helpers";

export const CatalogosIds = {
  Marcas: 1,
  Generos: 2,
  Tamanos: 3,
  Concentraciones: 4,
  Presentaciones: 5,
};

function ProductosCaracteristicas() {
  const createCatalogoRef = useRef();
  const selectedItem = useRef();
  const filtrosRef = useRef([]);
  const statusRef = useRef([]);
  const csvRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [productos, setProductos] = useState([]);

  const [catalogos] = useState([
    {
      nombre: "Marcas",
      value: "marcas",
      id: CatalogosIds.Marcas,
      nombreSingle: "Marca",
      pos: 0,
    },
    {
      nombre: "Generos",
      value: "generos",
      id: CatalogosIds.Generos,
      nombreSingle: "Genero",
      pos: 1,
    },
    {
      nombre: "Tamaños",
      value: "tamaños",
      id: CatalogosIds.Tamanos,
      nombreSingle: "Tamaño",
      pos: 2,
    },
    {
      nombre: "Concentraciones",
      value: "concentraciones",
      id: CatalogosIds.Concentraciones,
      nombreSingle: "Concentración",
      pos: 3,
    },
    {
      nombre: "Presentaciones",
      value: "presentaciones",
      id: CatalogosIds.Presentaciones,
      nombreSingle: "Presentación",
      pos: 4,
    },
  ]);

  const Menus = {
    Catalogos: 0,
    Status: 1,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [filtros] = useState([
    { type: Menus.Catalogos, name: "Caracteristicas SKU", canClear: false },
    {
      type: Menus.Status,
      name: "Estatus",
    },
    /* { type: "add_filter", name: "Agregar filtro" },*/
  ]);

  const [status] = useState([
    { nombre: "Activo", value: "activo", id: 1, pos: 0 },
    { nombre: "Inactivo", value: "inactivo", id: 2, pos: 1 },
  ]);

  /** PAging */

  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });
  /*{
    marcaIds: [],
    catalogoIds: [],
    tipoProductoIds: [],
    tagIds: [],
    sortBy: "NumProducto",
    sortAsc: false,
    isActivo: true,
    texto: "",
  });*/

  const fetchData = async (resetPageNumber = true) => {
    let criteria = searchCriteria;

    if (resetPageNumber) {
      /// reset pag info
      pagingInfoRef.current.resetPageInfo();
    }

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  useEffect(() => {
    updateSelectesItem(catalogos[0]);
    fetchData();
  }, []);

  function updateSelectesItem(item) {
    selectedItem.current = item;
    updateCaracteristicasFilter();
  }

  function createItem(event) {
    console.log(event);
    loadItem({});
  }

  function reloadProductos() {
    fetchData(false);
  }

  function loadItem(item) {
    setModalData(item);

    createCatalogoRef.current.toggleModal();
  }

  /**
   * Search handler
   */
  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    criteria["nombre"] = e;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      }
    });
  }

  const handleCatalogoClick = async (event, item, options) => {
    //onClick(item, options);
    console.log("Clicked!" + item + options);

    updateSelectesItem(item);

    let criteria = searchCriteria;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  const updateCaracteristicasFilter = () => {
    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Catalogos;
    });

    if (index === -1) {
      return;
    }

    const item = selectedItem.current;
    var marcasNames = item.nombre;

    if (index >= filtrosRef.current.length) return;
    filtrosRef.current[index].toka(marcasNames);
  };
  const clearStatusFilter = () => {
    status.forEach((item, index) => {
      item.checked = false;
      statusRef.current[index].checked = false;
    });

    //  setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    /*
    mantener posicion
    pagingInfoRef.current.resetPageInfo();
    */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);
    let response = null;

    const item = selectedItem.current;

    if (CatalogosIds.Marcas === item.id) {
      setIsLoading(true);
      response = await api.searchMarcas(criteria).catch((error) => {
        toast.error("Error al buscar Marcas.");
        setIsLoading(false);
      });
      if (!response) return;
    } else if (CatalogosIds.Generos === item.id) {
      response = await api.searchGeneros(criteria).catch((error) => {
        toast.error("Error al buscar Generos.");
        setIsLoading(false);
      });
    } else if (CatalogosIds.Tamanos === item.id) {
      response = await api.searchTamaños(criteria).catch((error) => {
        toast.error("Error al buscar Tamaños.");
        setIsLoading(false);
      });
    } else if (CatalogosIds.Concentraciones === item.id) {
      response = await api.searchConcentraciones(criteria).catch((error) => {
        toast.error("Error al buscar Concentraciones.");
        setIsLoading(false);
      });
    } else if (CatalogosIds.Presentaciones === item.id) {
      response = await api.searchPresentaciones(criteria).catch((error) => {
        toast.error("Error al buscar Presentaciones.");
        setIsLoading(false);
      });
    } else {
      return;
    }

    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    setProductos(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados
    const item = selectedItem.current;

    let filename = "caracteristicasSKU";
    if (CatalogosIds.Marcas === item.id) {
      filename += "+Marcas";
    } else if (CatalogosIds.Generos === item.id) {
      filename += "+Generos";
    } else if (CatalogosIds.Tamanos === item.id) {
      filename += "+Tamanos";
    } else if (CatalogosIds.Concentraciones === item.id) {
      filename += "+Concentraciones";
    } else if (CatalogosIds.Presentaciones === item.id) {
      filename += "+Presentaciones";
    }

    filename += ".csv";

    const csvString = [
      ["Id", "Nombre", "Nombre Corto", "Estatus"], // Specify your headers here
      ...productos.map((item) => {
        const id = item.num ?? "";

        return [
          id,
          item.nombre ?? "",
          item.nombreCorto ?? "",
          handleStatus(item).text,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, filename);
  }

  return (
    <>
      <ExportCSV ref={csvRef} />

      <div className="card recent-sales overflow-auto">
        <div className="separator"></div>
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className="header">
              <SearchBar onChange={(e) => onChangeSearchText(e)} />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginLeft: "0px" }}
                disabled={isLoading}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>
              <button className="btn btn-primary" onClick={createItem}>
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  {`Crear ${selectedItem?.current?.nombre}`}
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            >
              {filtros.map((item, index) => {
                return (
                  <>
                    <FilterButton
                      key={index}
                      ref={(el) => (filtrosRef.current[index] = el)}
                      name={item.name}
                      canClear={item.canClear}
                      clearCallback={(ble) => clearCallback(item)}
                    >
                      <ul
                        className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                        aria-labelledby="dropdownMenuClickableInside"
                      >
                        {item.type === Menus.Catalogos &&
                          catalogos.map((item, index) => {
                            const selected =
                              selectedItem?.current?.id === item.id;

                            return (
                              <TableOptionCheck
                                key={index}
                                ref={(el) => (statusRef.current[index] = el)}
                                item={item}
                                filterType={FilterType.OptionRadio}
                                onClick={handleCatalogoClick}
                                checked={selected}
                              />
                            );
                          })}

                        {item.type === Menus.Status &&
                          status.map((item, index) => {
                            return (
                              <TableOptionCheck
                                key={index}
                                item={item}
                                onClick={handleStatusClick}
                              />
                            );
                          })}
                      </ul>
                    </FilterButton>
                  </>
                );
              })}
            </div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item) => {
              let page = pagingInfoRef.current.pageNumber();
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>

        <div className="card-body">
          <ProductosTable2
            items={productos}
            openItem={loadItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
          />
        </div>

        <CreateCatalogoItem
          ref={createCatalogoRef}
          item={modalData}
          catalogoItem={selectedItem.current}
          reloadItems={reloadProductos}
        />
      </div>
    </>
  );
}

export default ProductosCaracteristicas;
